import Vue from 'vue'
import Vuex from 'vuex'

import Materias from './modules/materias'
import Aulas from './modules/aulas'
import Estudos from './modules/estudos'
 import Mensagens from './modules/mensagens'
import Login from './modules/login'

Vue.use(Vuex)

const store = new Vuex.Store({
   modules:{
       materias:Materias,
       aulas:Aulas,
       estudos:Estudos,
       mensagens:Mensagens,
       login:Login
   }
})

export default store